<script lang="ts">
	import {  storeSearchedText, storeSearchModal } from '$lib/js/stores'
	import { t } from 'svelte-i18n-lingui'
	import { page } from '$app/stores'
	import { goto } from '$app/navigation'

	function openSearch() {
		$storeSearchModal = true
		if(!$page.url.searchParams.get('search')){
			$page.url.searchParams.set('search', $storeSearchedText)
			goto($page.url.href)
		}
	}
</script>

<input
	type="search"
	on:focus={() => openSearch()}
	placeholder={$t`Search for a product...`}
/>
<button on:click={() => openSearch()} class="search" aria-label={$t`Search`}>
	<span class="icon icon-search"></span>
</button>

<style lang="scss">
	input {
		height: 36px;
		font-size: 14px;
		width: 100%;
		border: none;
		background: var(--grey);
		padding: 5px 12px;

		&:focus {
			outline: none;
		}
	}

	button {
		display: flex;
		position: absolute;
		right: 0;
		top: 0;
		bottom: 0;

		span {
			width: 36px;
			height: 36px;
			display: flex;
			align-items: center;
			justify-content: center;
			background: var(--main);
			color: white;
			font-weight: 700;
		}
	}
</style>
